import { memo } from 'react';

import { Box, Text, TextButton } from '@zillow/constellation-10';
import {
  IconMailOutline,
  IconNoteOutline,
  IconPhoneOutline,
  IconQuestionMarkCircleOutline,
} from '@zillow/constellation-icons';

import { ZILLOW_LEASES_TENANT_HELP, ZILLOW_RENTAL_MANAGER_SUBMIT_REQUEST } from '../../../constants/stringConstants';

export default memo(function ContactAnswer() {
  return (
    <Box css={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 'tighter' }}>
      <TextButton asChild icon={<IconQuestionMarkCircleOutline />}>
        <a target="_blank" rel="noopener noreferrer" href={ZILLOW_LEASES_TENANT_HELP}>
          Common questions
        </a>
      </TextButton>
      <TextButton asChild icon={<IconNoteOutline />}>
        <a target="_blank" href={ZILLOW_RENTAL_MANAGER_SUBMIT_REQUEST} rel="noopener noreferrer">
          Submit a request
        </a>
      </TextButton>
      <TextButton asChild icon={<IconMailOutline />}>
        <a href={`mailto:leases@zillow.com`}>Email us</a>
      </TextButton>
      <TextButton asChild icon={<IconPhoneOutline />}>
        <a href="tel:8553139633">(855) 313-9633</a>
      </TextButton>
      <Text css={{ textStyle: 'body-xs', color: 'text.subtle' }}>Available Mon–Fri 8am–4pm PT</Text>
    </Box>
  );
});
